<template class="app">
  <teleport to="head">
    <MetaTags
      title="Reverse IP Lookup"
      description="Find the domain name that is connected to an IP address. Check if the any websites are hosted on an IP by doing a reverse DNS lookup."
      url="https://www.nslookup.io/reverse-ip-lookup/"
    />
  </teleport>
  <HeaderComponent :domain-search-to-url="(encodedDomain) => `/ip/${encodedDomain}/domain-names/`" search-button-text="Reverse lookup" :autocomplete-enabled="false" />
  <div class="bg-neutral-100">
    <main class="container mx-auto">
      <div class="max-w-lg min-h-[calc(100vh-250px)] mx-auto text-center">
        <form class="text-base flex flex-col items-center justify-center min-h-screen" autocomplete="off">
          <h1 class="font-extrabold text-4xl max-w-full my-8">Reverse IP lookup</h1>
          <DomainSearch
            class="h-12 mb-6 max-w-full w-[500px]"
            autofocus
            emphasize
            :autocomplete-enabled="false"
            buttonText="Reverse lookup"
            placeholder-text="IP address"
            @submitted="redirectTo" />
          <p class="mt-8 mb-20 text-center max-w-full h-20 w-[500px] text-neutral-800">Find the domain name that is connected to an IP address. Check if the any websites are hosted on an IP by doing a reverse DNS lookup.<br />For example, try
            <router-link to="/ip/91.198.174.192/domain-names/" title="Domain names for 91.198.174.192" class="text-blue-600 hover:text-blue-800 hover:underline">91.198.174.192</router-link>
            or
            <router-link to="/ip/1.1.1.1/domain-names/" title="Domain names for 1.1.1.1" class="text-blue-600 hover:text-blue-800 hover:underline">1.1.1.1</router-link>
            to view their domain names.
          </p>
          <AdUnit class="mt-8 mx-auto" :config="ReverseIpLookup" />
        </form>
      </div>
    </main>
  </div>
  <FooterComponent />
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import MetaTags from '@/components/MetaTags.vue';
import AdUnit from '@/components/ads/AdUnit.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { ReverseIpLookup } from '@/common/adSlots';

const router = useRouter();

function redirectTo(ip: string): void {
  router.push(`/ip/${domainNameToUrlPath(ip)}/domain-names/`);
}
</script>
